import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { DIET_NUTRITION_FIELDS } from "types";

import { patientNutritionApi } from "../../../apis";
import { PATIENT_SECTIONS } from "./detail/PatientDetail";
import IntakeField from "./IntakeField";
import IntakeHeader from "./IntakeHeader";
import LayoutWrapper from "./LayoutWrapper";

const DietAndNutrition: React.FC<{ patientId: string }> = ({ patientId }) => {
  const { data, isError, error } = useQuery({
    queryKey: ["dietAndNutrition", patientId],
    queryFn: async () => {
      if (!patientId) return null;
      return patientNutritionApi.getNutritionAndDietByPatientId({
        patientId,
      });
    },
    enabled: !!patientId,
  });
  React.useEffect(() => {
    if (isError && error) {
      console.error("DietAndNutrition query error:", error);
    }
  }, [isError, error]);

  const displayData = {
    dietType: data?.dietType ?? "",
    breakfast: data?.breakfast ?? "",
    lunch: data?.lunch ?? "",
    dinner: data?.dinner ?? "",
    snacksOrBeverages: data?.snacksOrBeverages ?? "",
    waterPerDay: data?.waterPerDay?.toString() ?? "",
    foodInsensitivities: data?.foodInsensitivities ?? "",
    additionalInformation: data?.additionalInformation ?? "",
  };

  const renderField = (metric: (typeof DIET_NUTRITION_FIELDS)[number]) => {
    const value = displayData[metric.key as keyof typeof displayData] as string;
    return <IntakeField label={metric.label} value={value} disabled={true} />;
  };

  return (
    <Box sx={{ mt: 2 }}>
      <IntakeHeader title={PATIENT_SECTIONS.dietNutrition.label} />

      <LayoutWrapper itemsPerRow={2} spacing={3}>
        {DIET_NUTRITION_FIELDS.map(renderField)}
      </LayoutWrapper>

      <IntakeField
        label="Additional Information"
        value={displayData.additionalInformation ?? ""}
        disabled={true}
        rows={3}
      />
    </Box>
  );
};

export default DietAndNutrition;
